<template>
  <div>
    <div class="app-showcase-process-step__one mb-40">
      <div class="container-fluid container-fluid--cp-150">
        <div class="row flex-column-reverse flex-lg-row align-items-center">
          <div class="col-lg-5">
            <div class="app-showcase-process-step__media text-center wow move-up">
              <img :src="img" class="img-fluid" alt="thumbnail" />
            </div>
          </div>
          <div class="col-lg-7">
            <div class="app-showcase-process-step__content section-space--mt_40">
              <div class="app-showcase__inner">
                <h4 class="font-weight--light wow move-up">{{ title }}</h4>
                <div class="sub-text section-space--mb_40 wow move-up">
                  {{ desc }}
                </div>
                <div class="sub__title mb-20 wow move-up">
                  <h6 class="font-weight--blod">{{ subtitle }}</h6>
                </div>
                <div class="wow move-up">
                  <b-form @submit.prevent="onSubmit" @reset="onReset" v-if="show">
                    <b-form-group id="input-group-1" label="Email Address:" label-for="input-1">
                      <b-form-input
                        id="input-1"
                        v-model="$v.form.email.$model"
                        :state="validateState('email')"
                        aria-describedby="input-1-live-feedback"
                        type="email"
                        class="form-input"
                        placeholder=""
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-1-live-feedback"
                        >This field is required.
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Password:" label-for="input-2">
                      <b-form-input
                        id="input-2"
                        v-model="$v.form.password.$model"
                        :state="validateState('password')"
                        aria-describedby="input-2-live-feedback"
                        type="password"
                        class="form-input"
                        placeholder=""
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-2-live-feedback"
                        >This field is required.
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <div v-if="this.error" class="alert alert-danger" role="alert">
                      Email address and/or password is invalid. Please try again.
                    </div>

                    <div class="btn-sowcase section-space--mb_40 wow move-up">
                      <b-button type="submit" variant="primary" class="scroll btn btn--green"
                        >Log In</b-button
                      >
                    </div>

                    <div>
                      Don't have a profile yet?
                      <a href="/register" class="hover-style-link hover-style-link--green">
                        Sign Up</a
                      >
                    </div>

                    <div>
                      Don't remember your password?
                      <a href="/forgot-password" class="hover-style-link hover-style-link--green">
                        Reset Password</a
                      >
                    </div>

                    <!-- testing -->
                    <!-- <b-button type="reset" variant="danger">Reset</b-button> -->
                  </b-form>
                  <!-- <b-card class="mt-3" header="Form Data Result">
                                <pre class="m-0">{{ form }}</pre>
                                </b-card> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterMain FooterStyle="bg_drak-footer" />
  </div>
</template>

<script>
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { email, required } from 'vuelidate/lib/validators'

import FooterMain from '@/components/FooterMain'

import { handleGlobalError } from '../util'

export default {
  name: 'LoginScreen',
  mixins: [validationMixin],
  components: {
    FooterMain,
  },
  data() {
    return {
      loading: false,
      img: require('../assets/img/hero/startup/top.png'),
      subtitle: 'Log In',
      title: 'The fun begins with a Pixel Profile!',
      desc: 'A Pixel Profile is required in order to play some Pixel games (including the PixelDebates trading card game).  Your profile is where you can deposit $PXL for instant and feeless use in our games.',
      form: {
        email: null,
        password: null,
      },
      show: true,
      error: false,
    }
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  async mounted() {
    if (this.$store.getters.user) {
      this.$router.push('/profile')
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async onSubmit(event) {
      event.preventDefault()
      this.loading = true
      try {
        const resp = await axios.post(`${process.env.VUE_APP_PXL_API}/authentication`, {
          strategy: 'local',
          email: this.form.email,
          password: this.form.password,
        })
        this.loading = false
        this.$store.commit('initializeSession', resp.data)

        const accessToken = this.$store.getters.accessToken
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken

        // check if the user is verified and has a walletAddress
        if (this.$store.getters.user.isVerified === false) {
          this.$router.push({ path: '/verify', query: { email: this.$store.getters.user.email } })
        } else if (this.$store.getters.user.walletAddress === null) {
          this.$router.push({ path: `associate-wallet` })
        } else {
          this.$router.push('/profile')
        }
      } catch (err) {
        this.loading = false
        console.error('Error Logging in', err)
        // if (err && err.response && err.response.status !== 401) {
        handleGlobalError(this, err, 'login')
        // } else {
        // this.error = true
        // }
      }
    },
    onReset(event) {
      event.preventDefault()
      // Reset  form values
      this.form.email = ''
      this.form.password = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
  },
}
</script>
<style>
.form-input,
.alert {
  width: 50%;
}
@media handheld, only screen and (max-width: 425px) {
  .form-input,
  .alert {
    width: 100%;
  }
}
</style>
